<template>
  <div class="condition_query">
    <h1>{{ $t("tool.querytitle") }}</h1>
    <div class="form_com">
      <el-row class="search_com tact_search">
        <el-col :span="5" class="port_com port_first">
          <span>{{ $t("header.searchbar.airline") }}</span>
          <el-input
            class="port_carrier"
            placeholder="Airline"
            v-model="carrierCodes"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="8" class="port_com">
          <span>{{ $t("home.departure") }}</span>
          <el-input
            placeholder="PEK"
            maxlength="3"
            v-model="depCodes"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="8" class="port_com" style="width:300px;">
          <span>{{ $t("home.destination") }}</span>
          <el-input
            placeholder="LAX"
            maxlength="3"
            v-model="desCodes"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="3" class="query_btn">
          <el-button type="primary" class="query" @click="tactQuery">{{ $t("home.book") }}</el-button>
        </el-col>
      </el-row>
      <el-row style="margin-bottom:28px;">
        <router-link class="tact_router" to="airport_code">{{
          $t("tool.toThreeCode")
        }}</router-link>
      </el-row>

      <div class="table_com">
        <div class="tab_head">
          <el-row>
            <el-col>
              <span>{{ $t("tool.level") }}</span>
            </el-col>
            <el-col>
              <span>{{ $t("tool.Freightrate") }}</span>
            </el-col>
          </el-row>
        </div>
        <div
          v-if="tactDataList.length > 0"
          class="tab_body"
          v-for="item in tactDataList"
        >
          <el-row v-if="item.tactM">
            <el-col>
              <span>M</span>
            </el-col>
            <el-col>
              <span>{{ !!item.tactM ? item.tactM : "—" }}</span>
            </el-col>
          </el-row>
          <el-row v-if="item.tactN">
            <el-col> <span></span>N </el-col>
            <el-col>
              <span>{{ !!item.tactN ? item.tactN : "—" }}</span>
            </el-col>
          </el-row>
          <el-row v-if="item.tact45">
            <el-col>
              <span>45</span>
            </el-col>
            <el-col>
              <span>{{ !!item.tact45 ? item.tact45 : "—" }}</span>
            </el-col>
          </el-row>
          <el-row v-if="item.tact100">
            <el-col>
              <span>100</span>
            </el-col>
            <el-col>
              <span>{{ !!item.tact100 ? item.tact100 : "—" }}</span>
            </el-col>
          </el-row>
          <el-row v-if="item.tact300">
            <el-col>
              <span>300</span>
            </el-col>
            <el-col>
              <span>{{ !!item.tact300 ? item.tact300 : "—" }}</span>
            </el-col>
          </el-row>
          <el-row v-if="item.tact500">
            <el-col>
              <span>500</span>
            </el-col>
            <el-col>
              <span>{{ item.tact500 ? item.tact500 : "—" }}</span>
            </el-col>
          </el-row>
          <el-row v-if="item.tact700">
            <el-col>
              <span>700</span>
            </el-col>
            <el-col>
              <span>{{ !!item.tact700 ? item.tact700 : "—" }}</span>
            </el-col>
          </el-row>
          <el-row v-if="item.tact1000">
            <el-col>
              <span>1000</span>
            </el-col>
            <el-col>
              <span>{{ !!item.tact1000 ? item.tact1000 : "—" }}</span>
            </el-col>
          </el-row>
          <el-row v-if="item.tact2000">
            <el-col>
              <span>2000</span>
            </el-col>
            <el-col>
              <span>{{ !!item.tact2000 ? item.tact2000 : "—" }}</span>
            </el-col>
          </el-row>
          <el-row v-if="item.tact3000">
            <el-col>
              <span>3000</span>
            </el-col>
            <el-col>
              <span>{{ !!item.tact3000 ? item.tact3000 : "—" }}</span>
            </el-col>
          </el-row>
          <el-row v-if="item.tact5000">
            <el-col>
              <span>5000</span>
            </el-col>
            <el-col>
              <span>{{ !!item.tact5000 ? item.tact5000 : "—" }}</span>
            </el-col>
          </el-row>
        </div>
        <div v-if="!tactDataList.length" class="tab_body">
          <el-row>
            <el-col>
              <span>—</span>
            </el-col>
            <el-col>
              <span>—</span>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<style type="text/css" scoped="true">
@import "~@/assets/css/view/tool/tool.css";
</style>
<script type="babel">
import YC_REQUEST_HANDLER from "@/api/request.js";
import UTILS from '@/utils/utils';
export default {
    data: function() {
        return {
            depCode: "",
            desCode: "",
            tactDataList: [],
            carrierCode: ""
        };
    },
    computed: {
        depCodes: {
            get: function() {
                return this.depCode;
            },
            set: function(val) {
                this.depCode = val.toUpperCase();
            }
        },
        desCodes: {
            get: function() {
                return this.desCode;
            },
            set: function(val) {
                this.desCode = val.toUpperCase();
            }
        },
        carrierCodes: {
            get: function() {
                return this.carrierCode;
            },
            set: function(val) {
                this.carrierCode = val.toUpperCase();
            }
        }
    },
    methods: {
        tactQuery: function() {
            if (!this.depCode) {
                this.$bus.emit("commmon-notification", null, "The port of departure cannot be empty");
                return false;
            }
            if (!this.desCode) {
                this.$bus.emit("commmon-notification", null, "The port of destination cannot be empty");
                return false;
            }
            var date = new Date();
            var flightDate = UTILS.getNowFormatDate(date);
            var url =
                "/api-saas/afbase/tact/tactinfo?appid=2f5c8988b17f" +
                "&departureStation=" +
                this.depCode +
                "&arrivalStation=" +
                this.desCode +
                "&carrierCode=" +
                this.carrierCode +
                "&flightDate=" +
                flightDate,
                successCallBack = function(response) {
                    _this.tactDataList=[]
                    if (response.code == 0) {
                        if(response.data.length>0){
                            for(var i=0;i< response.data.length;i++){
                                var item=response.data[0]
                            }
                            _this.tactDataList.push(item)
                        }else{
                            _this.tactDataList=[]
                        }

                    }
                },
                failCallBack = function(err) {
                    _this.$bus.emit("common-error-handler", err.message);
                },
                _this = this;
            YC_REQUEST_HANDLER.getJsonWithQuery( url, null, successCallBack, failCallBack);
        }
    }
};
</script>
